export default {
  newWindow: 'Åbner i nyt vindue',
}
